import WaitingScreen from "./screens/waiting-screen/waiting-screen";

function App() {
  return <WaitingScreen />;
}

export default App;
